export const redirectToLoginPage = (instance) => {
  // Check if any interaction is in progress
  if (
    instance?.inProgress === "login" ||
    instance?.inProgress === "acquireToken"
  ) {
    console.log(
      "An interaction is already in progress. Please wait for it to finish.",
    );
  } else {
    instance?.loginRedirect().catch((error) => {
      console.error("Error during loginRedirect:", error);
    });
  }
};

export const getFormatedDate = (inputDate) => {
  const date = new Date(inputDate);
  const options = { day: "2-digit", month: "short", timeZone: "UTC" };
  const formattedDate = date
    .toLocaleDateString("en-GB", options)
    .replace(",", "")
    .replace(" ", "-");
  return formattedDate;
};

export const formatToKOrM = (value) => {
  if (value >= 1e6) {
    return `${(value / 1e6)?.toFixed(2)}M`;
  } else if (value >= 1e3) {
    return `${(value / 1e3)?.toFixed(2)}K`;
  }
  return value?.toFixed(2);
};

export const formatToKOrMWithoutDecimal = (value) => {
  if (value >= 1e6) {
    return `${(value / 1e6)?.toFixed(0)}M`;
  } else if (value >= 1e3) {
    return `${(value / 1e3)?.toFixed(0)}K`;
  }
  return value?.toFixed(0);
};

export const getModuleNameBasedOnPath = (path) => {
  if (path === "/if") {
    return "IF";
  } else if (path === "/sno") {
    return "SNO";
  } else if (path === "/dom") {
    return "DOM";
  } else if (path === "/rr") {
    return "RR";
  } else if (path === "/dp") {
    return "DP";
  } else if (path === "/do") {
    return "DO";
  } else if (path === "/dip") {
    return "DIP";
  } else if (path === "/cp") {
    return "CP";
  } else if (path === "/nps") {
    return "NPS";
  } else if (path === "/fgs") {
    return "FGS";
  } else if (path === "/poos") {
    return "POOS";
  } else if (path === "/slp") {
    return "SLP";
  } else if (path === "/iof") {
    return "IOF";
  } else if (path === "/iofpb") {
    return "IOFPB";
  } else if (path === "/ds") {
    return "DS";
  } else if (path === "/ff") {
    return "FF";
  } else if (path === "/tm") {
    return "TM";
  } else if (path === "/erm") {
    return "ERM";
  }
  return null;
};

export function formatDollar(value, decimals = 2) {
  if (value === null || value === undefined || isNaN(value)) {
    return "$0";
  }

  const num = Number(value);
  const sign = num < 0 ? "-" : "";

  // Clean numeric string formatting
  const cleaned = Math.abs(num)
    .toFixed(decimals)
    .replace(/(\.\d*?[1-9])0+$/, "$1")
    .replace(/(\.0+|(?<=\.\d)0+)$/, "");

  const absValue = Number(cleaned); // convert back to number

  if (absValue >= 1000000000) {
    return `${sign}$${(absValue / 1000000000)
      .toFixed(decimals)
      .replace(/\.?0+$/, "")}B`;
  }

  if (absValue >= 1000000) {
    return `${sign}$${(absValue / 1000000)
      .toFixed(decimals)
      .replace(/\.?0+$/, "")}M`;
  }

  if (absValue >= 1000) {
    return `${sign}$${(absValue / 1000)
      .toFixed(decimals)
      .replace(/\.?0+$/, "")}K`;
  }

  return `${sign}$${cleaned}`;
}
